'use client'

import * as SheetPrimitive from '@radix-ui/react-dialog'

import {
    ISheetProps,
    ISheetTriggerProps,
    ISheetCloseProps,
    ISheetPortalProps,
    ISheetOverlayProps,
    ISheetContentProps,
    ISheetHeaderProps,
    ISheetFooterProps,
    ISheetTitleProps,
    ISheetDescriptionProps,
} from './Sheet.types'
import * as S from './Sheet.styles'

export const Sheet = ({ ...props }: ISheetProps) => {
    return <SheetPrimitive.Root {...props} />
}

export const SheetTrigger = ({ ...props }: ISheetTriggerProps) => {
    return <SheetPrimitive.Trigger {...props} />
}

export const SheetClose = ({ ...props }: ISheetCloseProps) => {
    return <SheetPrimitive.Close {...props} />
}

export const SheetPortal = ({ ...props }: ISheetPortalProps) => {
    return <SheetPrimitive.Portal {...props} />
}

export const SheetOverlay = ({ className, ...props }: ISheetOverlayProps) => {
    return <S.StyledOverlay className={className} {...props} />
}

export const SheetContent = ({ className, children, side = 'right', ...props }: ISheetContentProps) => {
    return (
        <SheetPortal>
            <SheetOverlay />
            <S.StyledContent $side={side} className={className} {...props}>
                {children}
                <S.StyledCloseButton>
                    <S.StyledCloseIcon />
                    <S.ScreenReaderText>Close</S.ScreenReaderText>
                </S.StyledCloseButton>
            </S.StyledContent>
        </SheetPortal>
    )
}

export const SheetHeader = ({ className, ...props }: ISheetHeaderProps) => {
    return <S.StyledHeader className={className} {...props} />
}

export const SheetFooter = ({ className, ...props }: ISheetFooterProps) => {
    return <S.StyledFooter className={className} {...props} />
}

export const SheetTitle = ({ className, ...props }: ISheetTitleProps) => {
    return <S.StyledTitle className={className} {...props} />
}

export const SheetDescription = ({ className, ...props }: ISheetDescriptionProps) => {
    return <S.StyledDescription className={className} {...props} />
}
